import { css } from '@emotion/react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const FullScreenCenter: React.FC<Props> = (props) => {
  const { children } = props;
  return (
    <div css={wrapperCss}>
      <div css={containerCss}>{children}</div>
    </div>
  );
};

const wrapperCss = css`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const containerCss = css`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
`;
